export const TAG_OPTIONS = [
  { label: "coming out" },
  { label: "sexuality" },
  { label: "gender" },
  { label: "identity" },
  { label: "school" },
  { label: "family + friends" },
  { label: "take action" },
  { label: "wellbeing" },
  { label: "indigenous" },
  { label: "QTIPOC" },
  { label: "interviews" },
  { label: "video" },
  { label: "wear-it-purple", hidden: true },
  { label: "trans-awareness-week", hidden: true },
  { label: "IDAHOBIT", hidden: true },
  { label: "home page", hidden: true },
]

export default { TAG_OPTIONS }
